import { useCaseList } from '@debbie/cortex/dist/cases/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Col, Row } from '@debbie/iris/dist/components/Grid/index.js'
import {
  Content,
  Loading,
  PageBase,
  Panel,
  Table,
} from '@debbie/iris/dist/components/index.js'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { CaseSummary } from './index.js'

const Cases = () => {
  const history = useHistory()
  const lang = useSelector((s: RootState) => s.lang)

  const caseListLoadable = useCaseList({}, 0, 100)
  const caseList = h.hasData(caseListLoadable) ? caseListLoadable.data : null

  useEffect(() => {
    if (caseList && caseList.items.length === 1) {
      const path = `/cases/${caseList.items[0].id}`
      history.push(path)
    }
  }, [caseList])

  return (
    <div>
      <Content>
        <PageBase>
          <Row>
            <Col size="md" width="12">
              <Panel header={lang.cases.caseOverview}>
                {caseList ? (
                  caseList.items.length > 0 ? (
                    <Table>
                      <tr>
                        <th>ID</th>
                        <th style={{ width: '120px' }} />
                      </tr>
                      {caseList.items.map((c) => (
                        <CaseSummary case={c} key={c.id} />
                      ))}
                    </Table>
                  ) : (
                    <div style={{ textAlign: 'center' }}>
                      <span
                        style={{
                          fontStyle: 'italic',
                          opacity: '0.8',
                          fontSize: '1em',
                        }}
                      >
                        {lang.debtorWeb.noCasesFound}
                      </span>
                    </div>
                  )
                ) : (
                  <Loading width="30px" />
                )}
              </Panel>
            </Col>
          </Row>
        </PageBase>
      </Content>
    </div>
  )
}

export default Cases
